import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
// import {AppDispatch, RootState} from "../../redux/store";

export const useAppDispatch = () => useDispatch<any>();
export const useAppSelector: TypedUseSelectorHook<any> = useSelector;

// FROM STORE.ts
// export type RootState = ReturnType<typeof rootReducer>
// export type AppStore = ReturnType<typeof setupStore>
// export type AppDispatch = AppStore['dispatch']